import { Dialog } from "@headlessui/react";
import { ModalFoterBox } from "../../components/box/Box";
import Button from "../../components/button/Button";
import { Modal, ModalProp } from "../../components/modal/Modal";
import { UserCardCreateState } from "../../model/Systemparameters";
import { DocumentArrowUpIcon } from "@heroicons/react/24/solid";

export type UserIdcardFileApplicationModalProps = {
  userCardCreateState?: UserCardCreateState;
  monthlyApplicationCount?: number;
  requestCardCount?: number;
  handle: (userCardCreateState: UserCardCreateState) => void;
  maxApplicationCount: number;
}

export const UserIdcardFileApplicationModal = ({
  open,
  toggle,
  closeOnClickOutside,
  userCardCreateState,
  handle,
  monthlyApplicationCount,
  maxApplicationCount,
}: ModalProp & UserIdcardFileApplicationModalProps) => {
  return (
    <>
      <Modal
        open={open}
        toggle={toggle}
        closeOnClickOutside={closeOnClickOutside}
      >
        <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white  text-left shadow-xl transition-all sm:w-full max-w-screen-md ">
          {(userCardCreateState !== undefined) ? (
            <>
              <div className="px-2 pb-4 sm:p-4">
                <div className="text-center sm:mt-3">
                  <Dialog.Title
                    as="h3"
                    className="text-left  text-lg font-medium leading-6 text-gray-900"
                  >
                    申請
                  </Dialog.Title>
                </div>
                <div className="mt-5">
                  アップロードしたExcelファイルを申請します。
                </div>
                <ul style={{ color: "green" }}>
                  <li className={"flex"}>
                    <DocumentArrowUpIcon className={"h-6 w-6 bold"} />
                    {userCardCreateState.dispExcelFileName}
                  </li>
                </ul>
              </div>
              <div className={'text-red-500'}>
                <p className="mb-1">　今月の申請回数：{monthlyApplicationCount}（上限{maxApplicationCount}回）</p>
                <p className="mb-1">　※申請から利用者IDカードがダウンロード可能になるまで5営業日ほどかかります。</p>
              </div>
              <br></br>
              <ModalFoterBox>
                <Button
                  size={'md'}
                  className="mx-2 mt-1 w-[132px]"
                  outline
                  onClick={toggle}
                >
                  キャンセル
                </Button>
                <Button
                  size={'md'}
                  className="mt-1 mr-2 w-[132px]"
                  onClick={() => handle(userCardCreateState)}>OK</Button>
              </ModalFoterBox>
            </>
          ) : (<></>)}
        </Dialog.Panel>
      </Modal>
    </>
  );
}
